import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CellRendererParams } from './types';

export const StartDayRenderer: FC<CellRendererParams> = ({ value }) => (
  <FormattedMessage
    id="templates.resource_management.tooltips.placeholder"
    values={{ startDay: value }}
  />
);
